// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"360":"698f7ca676d094f32738","600":"6d54984a5ce923377708"}[chunkId] + ".bundle.js";
};